import axios from "axios";
import Config from "@/config"

export default class RecipeService {
  getRecipesForUser(accesstoken) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/recipes",
        options
      )
      .then(res => res.data);
  }
  getRecipesByAppliance(accesstoken, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/recipes/" + serialNumber,
        options
      )
      .then(res => res.data);
  }
  getRecipeDetails(accesstoken, recipeId, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
      .get(
        Config.proxy + Config.url("event") + "/recipe/" + recipeId + (serialNumber!=null ? ("?serialNumber=" + serialNumber) : ""),
        options
      )
      .then(res => res.data);
  }
  saveRecipe(accesstoken, recipe, recipeId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("event") + "/recipe" + (recipeId!=null ? ("?recipeId=" + recipeId) : ""), recipe,
      options
      )
      .then(res => res.data);
  }
  deleteRecipe(accesstoken, recipeId, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .delete(
      Config.proxy + Config.url("event") + "/recipe/" + recipeId + (serialNumber!=null ? ("?serialNumber=" + serialNumber) : ""),
      options
      )
      .then(res => res.data);
  }
  shareRecipe(accesstoken, recipeId, serialNumber) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("event") + "/recipe/" + recipeId + "/share?serialNumber=" + serialNumber, null,
      options
      )
      .then(res => res.data);
  }
  associateRecipe(accesstoken, recipeId) {
    const options = {
      headers: { ...Config.headers(accesstoken), ...{} }
    };
    return axios
    .post(
      Config.proxy + Config.url("event") + "/recipe/associate?recipeId=" + recipeId, null,
      options
      )
      .then(res => res.data);
  }
    


}
